import { buildProps, definePropType } from "@xplus/utils/props";
import type { ExtractPropTypes, Component } from "vue";

export const timelineProps = buildProps({
  title: {
    type: String,
  },
  type: {
    type: String,
    default: "",
  },
  color: {
    type: String,
    default: "",
  },
  size: {
    type: String,
    default: "normal",
  },
  icon: {
    type: definePropType<string | Component>([String, Object]),
  },
  hollow: {
    type: Boolean,
    default: false,
  },
  leftWidth: {
    type: Number,
    default: 45,
  },
} as const);

export type TimelineProps = ExtractPropTypes<typeof timelineProps>;
